const Color = {
  grey: '#BFBFBF',
  volcano: '#FA541C',
  orange: '#FA8C16',
  yellow: '#FADB14',
  'light-green': '#A0D911',
  green: '#52C41A',
  'dark-green': '#52C41A',
  cyan: '#13C2C2',
  blue: '#1890FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magents: '#EB2F96',
};

export default Color;
